import { render, staticRenderFns } from "./TipDesignerModal.vue?vue&type=template&id=05cb0d95&"
import script from "./TipDesignerModal.vue?vue&type=script&lang=js&"
export * from "./TipDesignerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports